import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { IErmSdkModuleConfig } from './erm-sdk.module-config';
import { ErmApiClientBuilderService } from './api/erm-api-client-builder.service';
import { ErmApiClientConfig } from './api/erm-api-client-config';
import { ErmCapabilityApiClientService } from './api/erm-capability/erm-capability-api-client.service';
import { ErmCapabilityApiClientServiceFactory } from './api/erm-capability/erm-capability-api-client.service-factory';
import { AuthenticatedUserAccountResolverService } from './connect/authenticated-user-account-resolver.service';
import { EnvironmentLabelsComponent } from './components/env-labels/env-labels.component';
import { EnvironmentStatusComponent } from './components/env-status/env-status.component';
import { CommonModule } from '@angular/common';
import { ErmDevOpsApiClientService } from './api/erm-devops/erm-devops-api-client.service';
import { ErmDevOpsApiClientServiceFactory } from './api/erm-devops/erm-devops-api-client.service-factory';
import { AccountLinkCellComponent } from './components/ag-grid/account-link.cell.component';
import { ActionsCellComponent } from './components/ag-grid/actions.cell.component';
import { AlarmCdoSeverityCellComponent } from './components/ag-grid/alarm-cdo-severity.cell.component';
import { AlarmStateCellComponent } from './components/ag-grid/alarm-state.cell.component';
import { AlarmStateChangedCellComponent } from './components/ag-grid/alarm-state-changed.cell.component';
import { DataBindingCellComponent } from './components/ag-grid/data-binding.cell.component';
import { EnvironmentLinkCellComponent } from './components/ag-grid/environment-link.cell.component';
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
  declarations: [
    EnvironmentLabelsComponent, 
    EnvironmentStatusComponent,
    AccountLinkCellComponent,
    ActionsCellComponent,
    AlarmCdoSeverityCellComponent,
    AlarmStateCellComponent,
    AlarmStateChangedCellComponent,
    DataBindingCellComponent,
    EnvironmentLinkCellComponent,
  ],
  exports: [
    EnvironmentLabelsComponent, 
    EnvironmentStatusComponent,
    AccountLinkCellComponent,
    ActionsCellComponent,
    AlarmCdoSeverityCellComponent,
    AlarmStateCellComponent,
    AlarmStateChangedCellComponent,
    DataBindingCellComponent,
    EnvironmentLinkCellComponent,
    AgGridModule
  ],
  imports: [
    CommonModule,
    AgGridModule
  ],
  providers: [{
    provide: AuthenticatedUserAccountResolverService
  }]
})
export class ErmSdkModule {

  static forRoot(moduleConfig: IErmSdkModuleConfig): ModuleWithProviders<ErmSdkModule> {

    return {
      ngModule: ErmSdkModule,
      providers: [
        {
          provide: ErmApiClientConfig,
          useFactory: moduleConfig.ermApiClientConfigFactory,
          deps: moduleConfig.ermApiClientConfigFactoryDependencies
        },
        {
          provide: ErmApiClientBuilderService,
          deps: [HttpBackend]
        },
        {
          provide: ErmCapabilityApiClientService,
          useFactory: ErmCapabilityApiClientServiceFactory,
          deps: [
            ErmApiClientConfig,
            ErmApiClientBuilderService
          ]
        },
        {
          provide: ErmDevOpsApiClientService,
          useFactory: ErmDevOpsApiClientServiceFactory,
          deps: [
            ErmApiClientConfig,
            ErmApiClientBuilderService
          ]
        }
      ]
    };
  }
}
